export const ordered = ['medical', 'dental', 'vision'];

export const orderedWithPharmacy = ['medical', 'pharmacy', 'dental', 'vision'];

export default {
  medical: 'Medical',
  pharmacy: 'Pharmacy',
  dental: 'Dental',
  vision: 'Vision',
  ordered,
  orderedWithPharmacy,
};
